import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queries } from '../../common/api/queryKeys/queries';
import { useAbly } from '../../common/hooks/useAbly';
import { useRole } from '../../common/hooks/useRole';

export const useMessages = (offer) => {
    const role = useRole();
    const query = useQuery(queries.offers.detail(offer.id)._ctx.messages);
    const { subscribe, unsubscribe } = useAbly();

    useEffect(() => {
        if (!role) {
            return;
        }

        const topic = role?.isCustomer()
            ? `customers:${offer.customerId}:offers:${offer.id}:messages`
            : `suppliers:${offer.supplierId}:offers:${offer.id}:messages`;

        subscribe(topic, () => {
            query.refetch();
        });

        return () => unsubscribe(topic);
    });

    return {
        ...query,
        messages: query.data ?? [],
    };
};
